<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Cancelamento'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- No Result -->
            <div v-if="!loadingList && (dataCancel !== '' && !dataCancel.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataCancel.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total ({{ dataCancel.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> NOTA DO PRODUTO</th>
                        <th> NOTA DE ATENDIMENTO</th>
                        <th> PENSA EM VOLTAR?</th>
                        <th> MOTIVO</th>
                        <th> MENSAGEM</th>
                        <th> DATA</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataCancel">
                        <td><a v-bind:href="'/detalhes-da-empresa/' + c.companyId + '/' + c.context" target="_blank"
                               class="link">{{ c.companyName }}</a></td>
                        <td>{{ c.ratingMarQPonto }}</td>
                        <td>{{ c.ratingCustomerService }}</td>
                        <td>
                          <span v-if="c.mightBeBackInFuture">SIM</span>
                          <span v-else>NÃO</span>
                        </td>
                        <td>{{ c.cancelRequestMotive }}</td>
                        <td>{{ c.message }}</td>
                        <td>{{ c.createdAt | formatFullDate }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";

import {
  CANCEL_COMPANY_REQUEST
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";

export default {
  name: "list-cancel",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
  },
  data() {
    return {
      failRequest: false,
      loadingList: false,
      dataCancel: []
    }
  },
  methods: {
    getList() {
      this.loadingList = true;
      this.failRequest = false;
      let url = CANCEL_COMPANY_REQUEST;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT CANCEL_COMPANY_REQUEST:", response.data);

        this.dataCancel = response.data;
        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;
        this.failRequest = true;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/listCancel.vue